import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#rate" }),
    /*#__PURE__*/_createTextVNode(" Rate ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Used for rating ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIWithAllowHalf = _resolveComponent("EUIWithAllowHalf")
  const _component_EUIWithText = _resolveComponent("EUIWithText")
  const _component_EUIMoreIcons = _resolveComponent("EUIMoreIcons")
  const _component_EUIReadOnly = _resolveComponent("EUIReadOnly")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIWithAllowHalf),
    _createVNode(_component_EUIWithText),
    _createVNode(_component_EUIMoreIcons),
    _createVNode(_component_EUIReadOnly)
  ], 64))
}